export default "__VITE_ASSET__cde2cb70__"